import React, { useState } from "react";
import { Button, Container, Row, Alert } from "reactstrap";
import DocumentTitle from "react-document-title";
import { useDispatch } from "react-redux";
import * as authActions from "../actions/auth";
import { Loading } from "../loader/Loading";

const Login = () => {
  const dispatch = useDispatch(),
    [login, setLogin] = useState(false);
  const appLogin = () => {
    setLogin(true);
    dispatch(authActions.login());
  };
  return (
    <DocumentTitle title={`Login | Doorkeeper`}>
      <Container style={{ width: "50%", paddingTop: "12%" }}>
        {login && <Loading />}
        <Alert color="dark">
          <Container>
            <Row>
              <h3>
                Welcome to <span style={{ color: "#3399ff" }}>Doorkeeper</span>
              </h3>{" "}
            </Row>
            <Row>
              <Button
                color="primary"
                style={{ width: "100%" }}
                onClick={() => {
                  appLogin();
                  dispatch({ type: "SET_STORE", data: { store: true } });
                }}
              >
                Login
              </Button>
            </Row>
          </Container>
        </Alert>
      </Container>
    </DocumentTitle>
  );
};

export default Login;
